import React from 'react';
import {Icons, DynamicContainer, Edit, DurationTagPicker, List} from 'components';
import {bounce, keyBy, sortBy, useField, useEditableList, useDragStart, useGlobalDrop} from 'helpers';
import css from './subtasks.module.scss';

export function SubRoutines(props) {
  const [ { value }, , { setValue } ] = useField(props);

  const list = useEditableList(value, setValue, 'name');

  useGlobalDrop(grabbed => grabbed.type === 'subroutine', (event, grabbed) => {
    bounce(grabbed.target);
    const list = grabbed.target.closest('[aria-roledescription="list"]');
    const nodes = keyBy(list.querySelectorAll('[draggable]'), 'dataset.id');
    setValue(sortBy(value, ({id}) => {
      return id === grabbed.id ? grabbed.clientY : nodes[id].getBoundingClientRect().y;
    }));
  });

  return (
    <DynamicContainer>
      <List tiny-gutter className={css.list}>
        { value.map((item, index) =>
          <div key={item.id} data-id={item.id} {...useDragStart({type: 'subroutine', id: item.id})}>
            <Edit
              duration={item.duration}
              name={item.id}
              onKeyDown={list.onKeyDown}
              placeholder="Enter Subroutine.."
              Prefix={Handle}
              required={index === 0}
              setValue={list.setValue}
              status={item.status}
              Suffix={item.name && SubRoutineDuration}
              value={item.name}
            />
          </div>
        ) }
      </List>
    </DynamicContainer>
  );
}

function Handle() {
  return (
    <span className={css.prefix}>
      <Icons.HandleAlt />
    </span>
  );
}

function SubRoutineDuration({ setValue, name, duration }) {
  return (
    <DurationTagPicker
      value={duration}
      setValue={duration => setValue(duration, name, 'duration')}
      placeholder="+ duration"
    />
  );
}
